<!--
/**
  * 选择下拉框组件
  * @author weili
  */
-->
<template>
   <!-- 选择框 -->
   <el-select
      v-model="formData[value]"
      :multiple="multiple"
      :disabled="disabled"
      :clearable="clearable"
      :filterable="filterable"
      :placeholder="placeholder"
      :showOptions="showOptions"
      :hideOptions="hideOptions"
      :remote="remote"
      :remote-method="remoteMethod"
      @change="
            handleEvent(
              formData[value]
            )
          "
      style="width:100%;"
    >
    <el-option
        v-for="(childItem, childIndex) in listTypeInfo"
        :key="childIndex"
        :label="childItem.label"
        :value="childItem.value"
      />
  </el-select>

</template>
<script>
import mixin from '@/mixins/mixin'
export default {
    name: 'EXSelect',
    mixins: [mixin],
    props: {
        formData: {
        type: Object,
        default:{}
        },
        value: {
        type: String,
        default:""
        },
        multiple: {
        type: Boolean,
        default: false,
        },
        disabled: {
        type: Boolean,
        default: false,
        },
        clearable: {
        type: Boolean,
        default: true,
        },
        filterable: {
        type: Boolean,
        default: false,
        },
        placeholder :{
          type: String,
          default: "请选择",
        },
        dicCode :{
          type: String,
          default: "",
        },
        change: Function,
        listData:{
          type: Array,
          default:()=>[]
        },
        showOptions: {
          type: Array,
          default:()=>[]
        },
        hideOptions: {
          type: Array,
          default:()=>[]
        },
        remote: {
          type: Boolean,
          default: false,
        },
        remoteMethod: Function,
    },
    data() {
        return {
          listTypeInfo: []
        }
    },
    watch: { 
      listData(val) {
        this.initListTypeInfo()
      },
      dicCode(val) {
        this.initListTypeInfo()
      },
      hideOptions(val){
        this.initListTypeInfo()
      },
      showOptions(val){
        this.initListTypeInfo()
      }
    },
    created(){
      this.initListTypeInfo()
    },
    methods: {
        // 绑定的相关事件
        handleEvent(value) {
           this.$emit("change", value);
        },
        //初始化字典下拉框
        initListTypeInfo(){
            if(this.dicCode && this.dicCode.trim().length > 0){
              this.mixFeignDictDataList(this.dicCode).then((list)=>{
                this.listTypeInfo = list
                this.handleSelectOptions()
              })
            }else{
                this.listTypeInfo = this.listData
                this.handleSelectOptions()
            }
        },
        //设置下拉框选项显示/隐藏
        handleSelectOptions(){
          const list =  this.listTypeInfo
          if(this.showOptions && this.showOptions.length > 0){
            let data = []
            for(var i = 0; i < list.length; i++){
              for(var j = 0; j < this.showOptions.length; j++){
                  if(list[i].value == this.showOptions[j]){
                        data.push(list[i])
                        break;
                  }
              }
            }
            this.listTypeInfo = data
          }
          if(this.hideOptions && this.hideOptions.length > 0){
            let data = []
            data = data.concat(list)  //浅拷贝，避免修改字典数组
            for(var i = 0; i < list.length; i++){
              for(var j = 0; j < this.hideOptions.length; j++){
                  if(list[i].value == this.hideOptions[j]){
                        data.splice(i, 1);
                        break;
                  }
              }
            }
            this.listTypeInfo = data
          }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/EXForm/EXSelect.vue